import React from 'react'; 
import ReactDOM from 'react-dom/client'; 
import './index.css'; 
import './DarkTheme.css'; // 引入深色主题样式
import './ResponsiveStyles.css'; // 引入响应式样式
import './EditorStyles.css'; // 引入编辑器样式
import './MobileEditorFix.css'; // 引入移动端编辑器修复样式
import App from './App';
import reportWebVitals from './reportWebVitals';
import './utils/apiInterceptor'; // 导入API拦截器

// 🔥【前端日志清理】生产环境下静默所有 console 输出，确保用户浏览器控制台整洁
//    覆盖全项目所有代码文件的 console 调用（开发环境保留完整调试能力）
if (process.env.NODE_ENV === 'production') {
  const noop = () => {};
  const silentMethods = [
    'log', 'debug', 'info', 'warn', 'error',
    'table', 'dir', 'trace', 'dirxml',
    'group', 'groupCollapsed', 'groupEnd',
    'time', 'timeLog', 'timeEnd', 'count', 'countReset'
  ];
  silentMethods.forEach((m) => {
    if (typeof console[m] === 'function') console[m] = noop;
  });
}
 
const root = ReactDOM.createRoot(document.getElementById('root')); 
root.render( 
  <React.StrictMode> 
    <App /> 
  </React.StrictMode> 
); 
 
reportWebVitals(); 
